import React from "react";

import {
  NavLink,
  Container,
  Row,
} from "reactstrap";

function Footer() {
  return (
    <footer className="footer footer-big bg-default">
      <Container>
        <div className="content">
          <Row className="mb-3">
            <div className="column mx-auto">
              <img
                alt="..."
                className="logo"
                src={require("assets/img/brand/blue.png")}
              ></img>
            </div>
          </Row>
          <Row lg="10">
            <div className="mx-auto">
              <p className="text-center text-white">Copyright &#169; 2025 CrypTegridy LTD.</p>
            </div>
          </Row>
        </div>
        <hr className="bg-white opacity-3"></hr>
        <div className="column">
          <ul className="d-flex justify-content-center">
            <li>
              <NavLink href="/terms-and-conditions" onClick={SubmitEvent}>
                Terms &amp; conditions
              </NavLink>
            </li>
            <li>
              <NavLink href="/privacy-policy" onClick={SubmitEvent}>
                Privacy policy
              </NavLink>
            </li>
          </ul>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
